import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

import { LeaseInputLeaseFragment } from '../../fields/LeaseInput';
import { OperatorInputOperatorFragment } from '../../fields/OperatorInput';

export const TicketDetails = gql`
  fragment TicketDetails on Ticket {
    id
    date {
      display
    }
    ticket_number {
      id
      number
    }
    job {
      id
      mutable
      immutableReason: immutable_reason
      job_number
      state
      pdf_path
      lease {
        id
        lookup {
          ...LeaseInputLease
        }
        operator {
          id
          lookup {
            ...OperatorInputOperatorLookup
          }
        }
      }
    }
    operator: operator_lookup {
      ...OperatorInputOperatorLookup
    }
    lease: lease_lookup {
      ...LeaseInputLease
    }
    state
    department {
      id
      name
    }
    district {
      id
      name
    }
    well {
      id
      name
      lease {
        id
        name
        operator {
          id
          name
        }
      }
    }
  }
  ${LeaseInputLeaseFragment}
  ${OperatorInputOperatorFragment}
`;

/* Querying ticket information based on ticketId */
const GetTicketQuery = gql`
  query GetTicket($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      ...TicketDetails
    }
  }
  ${TicketDetails}
`;


const marshallSingleTicketData = ({ data, ownProps }) => {
  const results = querySelector(data, '$.ticket', []);
  const ticket = results[0];
  return {
    ...ownProps,
    data,
    ticket,
  };
};

const querySingleTicketData = graphql(GetTicketQuery, {
  props: marshallSingleTicketData,
});

export const querySingleTicketGQL = compose(
  querySingleTicketData,
  queryMetaHandler,
  omitProps(['data']),
);
